import { useMemo } from "react";

import { LABELLING } from "../config/labelling";
import { useAuth } from "../context/AuthContext";
import { resolveProductPresentationLabelling } from "../utils/productPresentation/labelling";

export function usePresentationLabelling(surfaceKey = "dashboard") {
  const { accountContext } = useAuth();
  const productPresentationProfile =
    accountContext?.productPresentationProfile ||
    accountContext?.deploymentProductPresentationProfile ||
    null;

  return useMemo(
    () =>
      resolveProductPresentationLabelling(productPresentationProfile, {
        surfaceKey,
        fallbackProfileId: LABELLING.PRODUCT_PRESENTATION_PROFILE_ID,
        fallbackAppName: LABELLING.APP_NAME,
      }),
    [productPresentationProfile, surfaceKey],
  );
}
